import MediumEditor from 'medium-editor';
import { Alpine as IAlpine } from 'alpinejs';
// @ts-ignore
// import EmbedButtonExtension from 'medium-editor-embed-button/dist/js/medium-editor-embed-button';

export default function (Alpine: IAlpine) {
  Alpine.directive('editable-content', (el) => {
    new MediumEditor(el, {
      toolbar: {
        buttons: [
            {
                name: 'h2',
                action: 'append-h2',
                aria: 'header type two',
                tagNames: ['h2'],
                contentDefault: '<span class="medium-title-large">T</span>',
                contentFA: '<i class="fa fa-header"><sup>2</sup>',
            },
            {
                name: 'h3',
                action: 'append-h3',
                aria: 'header type three',
                tagNames: ['h3'],
                contentDefault: '<span class="medium-title-small">T</span>',
                contentFA: '<i class="fa fa-header"><sup>3</sup>',
            },
            'bold',
            'italic',
            'anchor',
            {
                name: 'unorderedlist',
                action: 'insertunorderedlist',
                aria: 'unordered list',
                tagNames: ['ul'],
                useQueryState: true,
                contentDefault: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="14.8" height="15" viewBox="0 0 14.8 15">
                    <g>
                        <g>
                            <path d="M14.4,11.9H3.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h10.5c0.2,0,0.4,0.2,0.4,0.4S14.6,11.9,14.4,11.9z M14.4,7.8H3.9    c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h10.5c0.2,0,0.4,0.2,0.4,0.4S14.6,7.8,14.4,7.8z M14.4,3.8H3.9c-0.2,0-0.4-0.2-0.4-0.4    s0.2-0.4,0.4-0.4h10.5c0.2,0,0.4,0.2,0.4,0.4S14.6,3.8,14.4,3.8z"/>
                        </g>
                        <g>
                            <circle cx="0.4" cy="3.4" r="0.4"/>
                            <circle cx="0.4" cy="7.5" r="0.4"/>
                            <circle cx="0.4" cy="11.5" r="0.4"/>
                        </g>
                    </g>
                    <g>
                        <rect x="-0.1" fill="none width="15" height="15"/>
                    </g>
                  </svg>
                `,
                contentFA: '<i class="fa fa-list-ul"></i>',
            },
            // 'embedButton',
        ],
        updateOnEmptySelection: true,
      },
      placeholder: {
        text: el.getAttribute('placeholder') || '',
        hideOnClick: true,
      },
    });
  })
}
